export class Kevel {
  endpoint = 'https://e-11757.adzerk.net/api/v2';
  divName = null;
  lastParams = null;
  parentBlock = null;

  static get cachedIP() {
    return window._kevelClientIP || null;
  }

  static set cachedIP(ip) {
    window._kevelClientIP = ip;
  }

  static get ipPromise() {
    return window._kevelIpPromise || null;
  }

  static set ipPromise(promise) {
    window._kevelIpPromise = promise;
  }

  async getClientIP() {
    if (Kevel.cachedIP) return Kevel.cachedIP;

    if (Kevel.ipPromise) return Kevel.ipPromise;

    // https://ipinfo.io/json
    // https://api.ipify.org?format=json
    Kevel.ipPromise = fetch('https://ipinfo.io/json')
      .then((res) => res.json())
      .then((data) => {
        Kevel.cachedIP = data.ip;
        Kevel.ipPromise = null;
        return data.ip;
      })
      .catch((err) => {
        Kevel.ipPromise = null;
        throw err;
      });

    return Kevel.ipPromise;
  }

  setDivName(divName) {
    this.divName = divName;
    return this;
  }

  setParent(block) {
    this.parentBlock = block;
    return this;
  }

  get1PartyCookie() {
    let cookieData = document.cookie;
    let match = cookieData.match(/adstax_uid=([^;]+)/);
    let value = match ? match[1] : null;
    if (value !== null) return value;
  }

  getUserConsent() {
    return localStorage.getItem('accept_gdpr') ? true : false;
  }

  load(placements, keywords = null) {
    this.lastParams = [placements, keywords];
    const divName = this.divName;

    this.getClientIP().then((ip) => {
      fetch(this.endpoint, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'User-Agent': window.navigator.userAgent,
        },
        body: JSON.stringify({
          placements: placements,
          keywords: keywords,
          enableBotFiltering: true,
          user: {
            key: this.get1PartyCookie(),
          },
          ip: ip,
          consent: {
            gdpr: this.getUserConsent(),
          },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          document.dispatchEvent(
            new CustomEvent(`onKevelSuccess-${divName}`, {
              detail: data,
            })
          );
        })
        .catch((error) => {
          document.dispatchEvent(
            new CustomEvent(`onKevelError-${divName}`, {
              detail: error,
            })
          );
        })
        .finally(() => {
          document.dispatchEvent(new CustomEvent(`onKevelComplete-${divName}`));
        });
    });

    return this;
  }

  onSuccess(callback) {
    document.addEventListener(`onKevelSuccess-${this.divName}`, callback);
    return this;
  }

  onError(callback) {
    document.addEventListener(`onKevelError-${this.divName}`, callback);
    return this;
  }

  onComplete(callback) {
    document.addEventListener(`onKevelComplete-${this.divName}`, callback);
    return this;
  }

  onReload() {
    const parentBlock = document.getElementById(this.parentBlock);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        this.load(...this.lastParams);
      });
    });

    const config = {
      attributes: true,
      childList: true,
      characterData: true,
    };

    observer.observe(parentBlock, config);
    return this;
  }

  sendImpression(element, campaign) {
    const viewedBanners = new Set();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entrie, index) => {
          if (entrie.isIntersecting && !viewedBanners.has(campaign.flightId)) {
            viewedBanners.add(campaign.flightId);
            fetch(campaign.impressionUrl);
            getBannerPushGTM('viewBanner', index, entrie.target.firstElementChild);
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(element);
    return this;
  }

  sendViewableImpression(element, campaign) {
    const viewedBanners = new Set();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entrie, index) => {
          if (entrie.isIntersecting && !viewedBanners.has(campaign.flightId)) {
            viewedBanners.add(campaign.flightId);
            fetch(campaign.events[0].url);
            getBannerPushGTM('viewBanner', index, entrie.target.firstElementChild);
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(element);
    return this;
  }
}
